import { render, staticRenderFns } from "./NameGenerator.vue?vue&type=template&id=4f6280cc&scoped=true&"
import script from "./NameGenerator.vue?vue&type=script&lang=js&"
export * from "./NameGenerator.vue?vue&type=script&lang=js&"
import style0 from "./NameGenerator.vue?vue&type=style&index=0&id=4f6280cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6280cc",
  null
  
)

export default component.exports